// bfsg

import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import ShareIcon from 'assets/share.svg'
import useOutsideClick from 'hooks/useOutsideClick'
import Modal from './Modal'
import useShareCart from 'hooks/account/cart/useShareCart'
import useTranslations from 'hooks/useTranslations'
import { shareCartOpenModal } from './events'

type Props = {
  'data-cy-state': string
}

export default function ShareCart(props: Props) {
  const t = useTranslations<'molecules-account-CartSummary'>()
  const [showModal, setShowModal] = React.useState(false)
  const outsideClickRef = useOutsideClick(() => {
    setShowModal(false)
  })
  const shareCart = useShareCart()

  return (
    <Wrapper ref={outsideClickRef} data-cy-state={props['data-cy-state']}>
      <ShareIcon />

      <button
        data-cy-handle="open-modal-btn"
        onClick={() => {
          shareCartOpenModal()
          setShowModal(!showModal)
          shareCart.postCart()
        }}
        className="text"
      >
        {t('sharecart_share_text')}
      </button>
      {showModal && (
        <div
          className="modal"
          data-cy-state="show-modal"
          data-cy-handle="open-modal-btn"
          onClick={() => setShowModal(!showModal)}
        />
      )}
      {showModal && (
        <Modal
          data-cy-state="show-modal"
          setShowModal={setShowModal}
          loading={shareCart.loading}
          docId={shareCart.docId}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  gap: ${theme.spacing('xxs')};
  ${theme.ty('rc-base', '700')};
  text-decoration: underline;
  > .text {
    ${theme.ty('rc-base', '700')};
    cursor: pointer;
  }
  > svg {
    width: 18px;
    height: 21px;
  }
  > .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${theme.zIndex
      .theme_molecules_account_cartsummary_sharecart_Modal};
    width: 100vw;
    height: 100vh;
    background-color: rgba(30, 30, 30, 0.9);
  }
`
// wdv-2457
